<style lang="scss" scoped>
  .plan-price h1 {
    font-weight: 400;
    display: inline;
  }

  .card .card {
    border: 1px solid rgba(0, 40, 100, 0.12);
    border-radius: 3px;
  }

  .card-status {
    position: absolute;
    top: -1px;
    left: -1px;
    right: -1px;
    height: 3px;
    border-radius: 3px 3px 0 0;
    background: rgba(0, 40, 100, 0.12);
  }

  .card-body {
    flex: 1 1 auto;
    margin: 0;
    padding: 1.5rem 1.5rem;
    position: relative;
  }

  .card-category {
    font-size: 0.875rem;
    text-transform: uppercase;
    text-align: center;
    font-weight: 600;
    letter-spacing: .05em;
    margin: 0 0 .5rem;
  }

  .leading-loose {
    line-height: 2 !important;
  }
</style>

<template>
  <div class="card">
    <div class="card-header">
      {{ __('Novo Dispositivo') }}
      <a
        href="#"
        class="float-right"
        @click.prevent="cancel()"
      >
        <i class="fa fa-times" />
      </a>
    </div>

    <div class="card-body">
      <form>
        <div class="form-group">
          <div class="text-center">
            <h3 style="margin-bottom: 30px">
              {{ __('Escolha um plano') }}
            </h3>
            <!-- <p class="h6 text-muted font-weight-normal mb-4">
              Posteriormente, você pode atualizar, fazer o downgrade ou cancelar instantaneamente. Sem condições.
            </p> -->
          </div>
          <div class="row">
            <div
              class="col-sm-6 col-lg-3"
              v-for="(plan, index) in plans"
              :key="index"
              v-if="plan.sell"
            >
              <div class="card">
                <div
                  class="card-status bg-green"
                  v-if="deviceForm.billingPlan === plan.plan"
                />
                <div class="card-body text-center">
                  <div class="card-category">
                    {{ plan.name }}
                  </div>
                  <div class="plan-price mt-2">
                    <span class="currency">{{ __('R$') }} </span>
                    <h1 class="display-4">
                      {{ plan.price / 100 }}<small> / mês</small>
                    </h1>
                  </div>
                  <hr>
                  <ul class="list-unstyled leading-loose">
                    <li
                      v-b-tooltip="feature.tooltip"
                      v-html="feature.text"
                      v-for="(feature, index) in plan.features"
                      :key="index"
                    />
                  </ul>

                  <div class="text-center mt-4">
                    <a
                      href="#"
                      class="btn btn-box-success active"
                      v-if="deviceForm.billingPlan === plan.plan"
                    >
                      <span>Selecionado</span>
                    </a>
                    <a
                      href="#"
                      class="btn btn-box"
                      @click.prevent="setBillingPlan(plan.plan)"
                      v-else
                    >
                      <span>Selecionar</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-12">
              <span
                class="form-text text-danger"
                v-show="deviceForm.errors.has('billingPlan')"
              >
                {{ deviceForm.errors.get('billingPlan') }}
              </span>
            </div>
          </div>
        </div>

        <div class="form-check">
          <input
            class="form-check-input"
            type="checkbox"
            v-model="deviceForm.terms"
            value="true"
          >
          <label class="form-check-label">
            {{ __('Eu entendo os riscos de violação dos termos de uso do') }}
            <a
              class="hyperlink"
              href="https://www.whatsapp.com/legal"
              target="_blank"
            >WhatsApp</a>,
            {{ __('tal como envio de spam e mensagens de marketing não solicitadas') }}.
          </label>
          <span
            class="form-text text-danger mb-3"
            v-show="deviceForm.errors.has('terms')"
          >
            {{ deviceForm.errors.get('terms') }}
          </span>
        </div>

        <div class="row m-t-40">
          <div class="col-md-6">
            <div class="float-right">
              <button
                type="submit"
                class="btn btn-box-success m-b-10"
                @click.prevent="save"
                :disabled="deviceForm.busy"
              >
                <span v-if="deviceForm.busy"><i class="fa fa-circle-o-notch fa-spin" /></span>
                <span v-else>{{ __('Salvar') }}</span>
              </button>
            </div>
            <div
              class="float-left"
              v-if="root"
            >
              <button
                type="submit"
                class="btn btn-box-success m-b-10"
                @click.prevent="save(true)"
                :disabled="deviceForm.busy"
              >
                <span v-if="deviceForm.busy"><i class="fa fa-circle-o-notch fa-spin" /></span>
                <span v-else>[Root] {{ __('Salvar') }}</span>
              </button>
            </div>
          </div>
          <div class="col-md-6">
            <div class="float-left">
              <button
                class="btn btn-box text-danger m-b-10"
                @click.prevent="cancel()"
              >
                <span>{{ __('Cancelar') }}</span>
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { VBTooltip } from 'bootstrap-vue';

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },

  props: {
    plans: {},
    root: {
      type: Boolean,
      default: false,
    },
  },

  mounted () {
    this.$root.$on('bv::modal::hide', (event, modalId) => {
      if (modalId == 'modal-tenant-invoice') {
        window.location.reload();
      }
    });
  },

  data () {
    return {
      deviceForm: new BulldeskForm({
        billingPlan: '',
        terms: false,
      }),
    };
  },

  methods: {
    save (add) {
      if (add === true) {
        Http.post('/device/root', this.deviceForm)
          .then(() => {
            window.location.reload();
          })
          .catch(() => {});

        return;
      }

      Http.post('/device', this.deviceForm)
        .then((device) => {
          Bus.$emit('tenantInvoice', device.metadata.invoice);
        })
        .catch((error) => {
          if (error.status === 402) {
            Alert.error(this.__('Assinatura não realizada. Contate o suporte.'));
          }
        });
    },

    setBillingPlan (plan) {
      this.deviceForm.billingPlan = plan;
    },

    cancel () {
      Bus.$emit('creatingButtonToggle');
    },
  },
};
</script>
